import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { APP_CONTENT_QUERY_KEYS } from '@/lib/constants/appContent';
import { AppContentApi } from './AppContentApi';

/**
 * Fetches a single listlist by ID via the detail endpoint.
 * Used for detail pages (Content Group, Category, Series).
 */
export function useAppContentListlist(llId: number) {
  const { selectedCId } = useAuth();

  return useQuery({
    queryKey: APP_CONTENT_QUERY_KEYS.detail(selectedCId ?? 0, llId),
    queryFn: () => AppContentApi.getListlist(selectedCId!, llId),
    enabled: selectedCId != null && llId > 0,
    staleTime: 2 * 60_000,
  });
}
